import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { getFirstError } from '../../forms/validation';
import { Errors } from '../errors/errors';

@Component({
  selector: 'app-list-input',
  templateUrl: './list-input.component.html',
  styleUrls: ['./list-input.component.scss'],
  standalone: false
})
export class ListInputComponent {

  @Input()
  public placeholder: string;

  @Input()
  public name: string;

  @Input()
  public bold = false;

  @Input()
  public errors: Errors = {};

  public listGroup: FormGroup = new FormGroup({});
  public validatorFns: ValidatorFn[];

  constructor() {
    this.addControl();
  }

  @Input()
  public set validators(validators: ValidatorFn[]) {
    this.validatorFns = validators;
    this.listNames.forEach(name => {
      const control = this.listGroup.get(name);
      control.clearValidators();
      control.setValidators(validators);
    });
  }

  @Input()
  public set group(formGroup: FormGroup) {
    if (!formGroup) {
      return;
    }
    this.listGroup = formGroup;
    this.addControl();
  }

  public get listNames(): string[] {
    return Object.keys(this.listGroup.controls)
      .sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
  }

  public autoReplaceLastControl(controlName: string) {
    if (this.isLastControl(controlName)) {
      this.addControl();
    }
  }

  public isLastControl(controlName: string): boolean {
    const keys = this.listNames;
    const lastKey = keys[keys.length - 1];
    return controlName === lastKey;
  }

  public deleteControl(controlName: string): void {
    this.listGroup.removeControl(controlName);
    this.listGroup.markAsTouched();
    this.listGroup.markAsDirty();
  }

  public addControl(initialValue = ''): void {
    let index = 0;
    const keys = Object.keys(this.listGroup.controls);
    if (keys.length > 0) {
      const last = keys[keys.length - 1];
      index = parseInt(last, 10) + 1;
    }

    const newControl = new FormControl(initialValue, this.validatorFns);
    this.listGroup.addControl(index.toString(10), newControl);
  }

  public getControl(controlName: string) {
    const abstractControl = this.listGroup.get(controlName);
    if (this.listGroup.disabled) {
      abstractControl.disable();
    } else {
      abstractControl.enable();
    }
    return abstractControl;
  }

  public showError(controlName: string) {
    const control = this.getControl(controlName);
    return control.touched && !!control.errors && this.errorPresentation(controlName);
  }

  public errorPresentation(controlName: string): string {
    return this.errors[getFirstError(this.getControl(controlName))];
  }
}
